import request from "./http";

class InboundRequestLogRepository
{
    async getOneById(id) {
        const path = "inbound-request-log/details";
        const method = "GET";
        const data = {
            id: id
        };

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("get one by id", error);
        }
    }

    async gridview(query) {
        const path = "inbound-request-log/gridview";
        const method = "POST";
        const data = query;

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("gridview", error);
        }
    }


}

export default InboundRequestLogRepository;